import Marquee from "react-fast-marquee";
import { Reveal, SectionLabel } from "./Reveal";

export const Sponsors = ({ section, sponsors = [] }) => {
  if (!section || sponsors.length === 0) return null;

  const SponsorContent = ({ sponsor }) => (
    <div className="group flex items-center gap-4 px-10 md:px-16">
      <span className="text-[#E85A24]/50 text-lg group-hover:text-[#E85A24] transition-colors">✦</span>
      {sponsor.logo ? (
        <img
          src={sponsor.logo}
          alt={sponsor.name}
          className="h-10 md:h-14 w-auto max-w-[220px] object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-[filter,opacity] duration-300"
        />
      ) : (
        <span className="font-oswald uppercase tracking-[0.25em] text-xl md:text-3xl text-[#A3A3A3]/60 group-hover:text-[#FAFAFA] transition-colors duration-300 whitespace-nowrap">
          {sponsor.name}
        </span>
      )}
    </div>
  );

  return (
    <section data-testid="sponsors-section" className="relative py-16 md:py-20 bg-[#050505] border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-10">
        <Reveal>
          <SectionLabel index={section.metadata?.section_index || "05"}>{section.eyebrow}</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-anton uppercase text-[#FAFAFA] text-3xl md:text-5xl leading-none">
            {section.title} <span className="text-[#E85A24]">{section.title_accent}</span>
          </h2>
        </Reveal>
      </div>

      <div className="border-y border-white/10 py-8 bg-[#0a0a0a]">
        <Marquee speed={35} gradient={false} pauseOnHover autoFill>
          {sponsors.map((sponsor, index) =>
            sponsor.website_url ? (
              <a
                key={sponsor.id || `${sponsor.name}-${index}`}
                data-testid={`sponsor-${index}`}
                href={sponsor.website_url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={sponsor.name}
              >
                <SponsorContent sponsor={sponsor} />
              </a>
            ) : (
              <div key={sponsor.id || `${sponsor.name}-${index}`} data-testid={`sponsor-${index}`}>
                <SponsorContent sponsor={sponsor} />
              </div>
            )
          )}
        </Marquee>
      </div>
    </section>
  );
};
